export const backendURL = 'https://connectpams.app';
//local- https://mymdconnect.techaffinity.us
//prod - https://connectpams.app 